import { useMediaQuery } from './use-media-query';

/**
 * Viewport breakpoints, kept in sync with Tailwind's `md` and `sm` so that a
 * JS branch and its `md:` / `sm:` utility counterpart flip on the same pixel.
 */
const BREAKPOINT_PX = {
  MOBILE: 768,
  SMALL_DEVICE: 640,
} as const;

/** True below Tailwind's `md` breakpoint — the phone/tablet layout. */
export const useIsMobile = (): boolean =>
  useMediaQuery(`(max-width: ${BREAKPOINT_PX.MOBILE - 1}px)`);

/** True below Tailwind's `sm` breakpoint — narrow phones only. */
export const useIsSmallDevice = (): boolean =>
  useMediaQuery(`(max-width: ${BREAKPOINT_PX.SMALL_DEVICE - 1}px)`);
